export default __webpack_public_path__ + "static/media/icon-info-panel-3.9e503100.svg";